"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _root = _interopRequireDefault(require("./style/root"));

var _button = _interopRequireDefault(require("./style/button"));

var _ripple = _interopRequireDefault(require("./style/ripple"));

var _animationContainer = _interopRequireDefault(require("./style/animationContainer"));

var _rounded = _interopRequireDefault(require("./theme/mixins/rounded"));

var _square = _interopRequireDefault(require("./theme/mixins/square"));

var _circle = _interopRequireDefault(require("./theme/mixins/circle"));

var _multiline = _interopRequireDefault(require("./theme/mixins/multiline"));

var _wide = _interopRequireDefault(require("./theme/mixins/wide"));

var _stretchHeight = _interopRequireDefault(require("./theme/mixins/stretchHeight"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RippleMemo = (0, _react.memo)(_ripple["default"], function (prevProps, nextProps) {
  return prevProps.theme === nextProps.theme;
});

var Button = _react["default"].forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      style = _ref.style,
      onClick = _ref.onClick,
      className = _ref.className,
      elementRef = _ref.elementRef,
      children = _ref.children,
      primary = _ref.primary,
      secondary = _ref.secondary,
      warning = _ref.warning,
      error = _ref.error,
      primaryInversion = _ref.primaryInversion,
      flat = _ref.flat,
      flatPrimary = _ref.flatPrimary,
      tag = _ref.tag,
      tagPrimary = _ref.tagPrimary,
      square = _ref.square,
      multiline = _ref.multiline,
      rounded = _ref.rounded,
      circle = _ref.circle,
      disabled = _ref.disabled,
      wide = _ref.wide,
      stretchHeight = _ref.stretchHeight,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["theme", "style", "onClick", "className", "elementRef", "children", "primary", "secondary", "warning", "error", "primaryInversion", "flat", "flatPrimary", "tag", "tagPrimary", "square", "multiline", "rounded", "circle", "disabled", "wide", "stretchHeight"]);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      animationItems = _useState2[0],
      setAnimationItems = _useState2[1];

  var removeRipple = (0, _react.useCallback)(function (key) {
    setAnimationItems(animationItems.filter(function (item) {
      return item.key !== key;
    }));
  }, []);
  var addRipple = (0, _react.useCallback)(function (e) {
    if (typeof onClick === 'function') {
      onClick(e);
    } // event.offsetX, event.layerX работают по разному в ФФ и хроме
    // потому что event.target разный


    var position = (0, _documentOffset["default"])(e.currentTarget),
        key = "ripple".concat(new Date().getTime());
    setAnimationItems([].concat((0, _toConsumableArray2["default"])(animationItems), [{
      key: key,
      top: e.pageY - position.top,
      left: e.pageX - position.left,
      onAnimationEnd: function onAnimationEnd() {
        return removeRipple(key);
      }
    }]));
  }, [onClick]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  var compiledTheme = (0, _react.useMemo)(function () {
    var result = memoTheme; // Important to copy nested object
    // mix "style" into theme for avoiding nested styling

    if (primary) {
      result = style ? _objectSpread({}, memoTheme.primary, {}, style) : memoTheme.primary;
    } else if (secondary || warning) {
      result = style ? _objectSpread({}, memoTheme.secondary, {}, style) : memoTheme.secondary;
    } else if (error) {
      result = style ? _objectSpread({}, memoTheme.error, {}, style) : memoTheme.error;
    } else if (primaryInversion) {
      result = style ? _objectSpread({}, memoTheme.primaryInversion, {}, style) : memoTheme.primaryInversion;
    } else if (flat) {
      result = style ? _objectSpread({}, memoTheme.flat, {}, style) : memoTheme.flat;
    } else if (flatPrimary) {
      result = style ? _objectSpread({}, memoTheme.flatPrimary, {}, style) : memoTheme.flatPrimary;
    } else if (tag) {
      result = style ? _objectSpread({}, memoTheme.tag, {}, style) : memoTheme.tag;
    } else if (tagPrimary) {
      result = style ? _objectSpread({}, memoTheme.tagPrimary, {}, style) : memoTheme.tagPrimary;
    }

    if (rounded) {
      result = _objectSpread({}, result, {}, (0, _rounded["default"])(result, memoTheme.palette));
    }

    if (square) {
      result = _objectSpread({}, result, {}, (0, _square["default"])(result, memoTheme.palette));
    }

    if (circle) {
      result = _objectSpread({}, result, {}, (0, _circle["default"])(result, memoTheme.palette));
    }

    if (multiline) {
      result = _objectSpread({}, result, {}, (0, _multiline["default"])(result, memoTheme.palette));
    }

    if (wide) {
      result = _objectSpread({}, result, {}, (0, _wide["default"])(result, memoTheme.palette));
    }

    if (stretchHeight) {
      result = _objectSpread({}, result, {}, (0, _stretchHeight["default"])(result, memoTheme.palette));
    }

    return result;
  }, [primary, secondary, error, primaryInversion, flat, flatPrimary, tag, tagPrimary, rounded, square, circle, multiline, wide, stretchHeight, memoTheme]);
  return _react["default"].createElement(_root["default"], {
    theme: compiledTheme,
    className: className
  }, _react["default"].createElement(_button["default"], (0, _extends2["default"])({}, rest, {
    onClick: addRipple,
    ref: ref || elementRef,
    disabled: disabled,
    theme: compiledTheme
  }), children, _react["default"].createElement(_animationContainer["default"], {
    theme: compiledTheme
  }, animationItems.map(function (item) {
    return _react["default"].createElement(RippleMemo, {
      theme: compiledTheme,
      key: item.key,
      style: {
        top: "".concat(item.top, "px"),
        left: "".concat(item.left, "px")
      },
      onAnimationEnd: item.onAnimationEnd
    });
  }))));
});

Button.defaultProps = {
  type: 'button',
  primary: false,
  secondary: false,
  warning: false,
  error: false,
  primaryInversion: false,
  flat: false,
  flatPrimary: false,
  tag: false,
  tagPrimary: false,
  square: false,
  multiline: false,
  rounded: false,
  circle: false,
  stretchHeight: false
};
Button.propTypes = {
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  warning: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  primaryInversion: _propTypes["default"].bool,
  flat: _propTypes["default"].bool,
  flatPrimary: _propTypes["default"].bool,
  tag: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  tagPrimary: _propTypes["default"].bool,
  square: _propTypes["default"].bool,
  wide: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     *@default 'inline-block'
     *@description 'display description'
     */
    display: _propTypes["default"].string,

    /**
     *@default 'block'
     */
    animationDisplay: _propTypes["default"].string,

    /**
     *@default palette.elLight
     */
    animationBackgroundColor: _propTypes["default"].string,

    /**
     *@default palette.gutter * 5 + 'px'
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default 'auto'
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default '2px'
     */
    borderRadius: _propTypes["default"].string,

    /**
     *@default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     *@default palette.twSemi
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     *@default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     *@default 'left'
     */
    textAlign: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    borderColor: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     *@default `0 2px 4px 0 ${palette.elShadowMain}`
     */
    boxShadow: _propTypes["default"].string,

    /**
     *@default palette.gutter + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default palette.gutter + 'px'
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default palette.gutter * 2 + 'px'
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default palette.gutter * 2 + 'px'
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default 'nowrap'
     */
    whiteSpace: _propTypes["default"].string,

    /**
     *@default 'none'
     */
    borderStyle: _propTypes["default"].string,

    /**
     *@default 0
     */
    borderWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default '#FFF'
     */
    rootBackground: _propTypes["default"].string,

    /**
     *@default palette.tInactive
     */
    focusColor: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    focusBorderColor: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    focusBackground: _propTypes["default"].string,

    /**
     *@default `0 2px 4px 0 ${palette.elShadowMain}`
     */
    focusBoxShadow: _propTypes["default"].string,

    /**
     *@default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    hoverBorderColor: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    hoverBackground: _propTypes["default"].string,

    /**
     *@default `0 2px 4px 0 ${palette.elShadowMain}`
     */
    hoverBoxShadow: _propTypes["default"].string,

    /**
     *@default palette.tActive
     */
    activeColor: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    activeBorderColor: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    activeBackground: _propTypes["default"].string,

    /**
     *@default `0 8px 8px 0 ${palette.elShadow}, 0 0 8px 0 ${palette.elShadow}`
     */
    activeBoxShadow: _propTypes["default"].string,

    /**
     *@default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    disabledBorderColor: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    disabledBackground: _propTypes["default"].string,

    /**
     *@default 'none'
     */
    disabledBoxShadow: _propTypes["default"].string
  }),
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  multiline: _propTypes["default"].bool,
  circle: _propTypes["default"].bool,
  rounded: _propTypes["default"].bool,
  stretchHeight: _propTypes["default"].bool
};
var _default = Button;
exports["default"] = _default;